import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Footer from 'components/Footer/Footer';
import Helmet from 'react-helmet';
import Header from './Header';
import Modal from '../../components/Modal/Modal';
import Join from '../../components/JoinModal/JoinModal';
import SubscribeModal from '../../components/SubscribeModal/SubscribeModal';

class Tariff extends Component {
  static propTypes = {
    history: PropTypes.objectOf(PropTypes.any),
    location: PropTypes.objectOf(PropTypes.any),
    user: PropTypes.shape({
      email: PropTypes.string
    })
  };
  state = {
    monthSubscribe: false,
    moreRules: false,
    modal: false,
    modalType: '',
    modalInnerType: '',
    tariff: {
      BASIC: [
        { price: 99, label: 'год' },
      ],
      STANDARD: [
        { price: 249, label: 'год' }
      ],
      PREMIUM: [
        { price: 599, label: 'год' },
      ],
      ELITE: [
        { price: 1199, label: 'год' },
      ],
      ENTERPRISE: []
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.setState({ moreRules: true }, () => window.scrollTo(0, 0));
    }
  }
  componentDidMount() {
    if (this.props.location.search === '?subId=full') {
      this.setState({ moreRules: true });
    }
  }
  render() {
    const styles = require('./Tariff.less');

    return [
      <Helmet
        key="0"
        htmlAttributes={{ lang: 'ru-RU' }}
        title="Тарифные планы онлайн сервиса для создания опросов и сбора отзывов (обратной связи) / оценок и аналитики от Клиентов (ЦА) – Mvoter.com"
        meta={[{ name: 'description', content: 'Тарифные планы онлайн сервиса для создания опросов и сбора отзывов (обратной связи) / оценок и аналитики от Клиентов (ЦА) – Mvoter.com' }]}
      />,
      <Header key="1" />,
      <div key="2" className={ styles.content }>
        <div className={ styles.inner }>
          <div className={ styles.wrap }>
            <h1>Перейдите на тариф "Enterprise" и получите максимальные преимущества</h1>
            <div className={ styles.tableWrap }>
              <table cellPadding="0" cellSpacing="0">
                <thead>
                  <tr>
                    <th width="30%" height="100" />
                    <th width="17%" className={ styles.basic }>
                      <span className={ styles.tariffName }>Basic</span>
                      {/* <span className={ styles.tariffDescrip }>Отличное решение для малого бизнеса</span> */}
                    </th>
                    <th width="17%" className={ styles.standard }>
                      <span className={ styles.tariffName }>Standard</span>
                      {/* <span className={ styles.tariffDescrip }>Для лидеров отрасли</span> */}
                    </th>
                    <th width="17%" className={ styles.premium }>
                      <div className={ styles.overflow } />
                      <span className={ styles.tariffName }>Premium</span>
                      {/* <span className={ styles.tariffDescrip }>Расширенный набор с большими возможностями</span> */}
                      <span className={ styles.whiteRect } />
                    </th>
                    <th width="17%" className={ styles.elite }>
                      <span className={ styles.tariffName }>Elite</span>
                      {/* <span className={ styles.tariffDescrip }>Для лидеров отрасли</span> */}
                    </th>
                    <th width="17%" className={ styles.enterprise }>
                      <span className={ styles.tariffName }>Enterprise</span>
                      {/* <span className={ styles.tariffDescrip }>Для лидеров отрасли</span> */}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="30%" height="140">
                      <div className={ styles.bigNotif }>Ежегодная подписка</div>
                      <div className={ styles.notif }>Самое выгодные предложение!</div>
                    </td>
                    <td width="17%">
                      <div className={ styles.price }><span>$99</span> в год</div>
                      <span className={ styles.hyperlink } onClick={ () => this.setState({ modalType: 'BASIC', modalInnerType: 'year' }) }>Купить</span>
                    </td>
                    <td width="17%">
                      <div className={ styles.price }><span>$249</span> в год</div>
                      <span className={ `${styles.popularSelectButton} ${styles.hyperlink}` } onClick={ () => this.setState({ modalType: 'STANDARD', modalInnerType: 'year' }) }>Купить</span>
                    </td>
                    <td width="17%">
                      <div className={ styles.price }><span>$599</span> в год</div>
                      <span className={ `${styles.popularSelectButton} ${styles.hyperlink}` } onClick={ () => this.setState({ modalType: 'PREMIUM', modalInnerType: 'year' }) }>Купить</span>
                    </td>
                    <td width="17%">
                      <div className={ styles.price }><span>$1199</span> в год</div>
                      <span className={ `${styles.popularSelectButton} ${styles.hyperlink}` } onClick={ () => this.setState({ modalType: 'ELITE', modalInnerType: 'year' }) }>Купить</span>
                    </td>
                    <td width="17%"><span className={ styles.link } onClick={ () => this.setState({ modalType: 'ENTERPRICE' }) }>свяжитесь с нами</span></td>
                  </tr>
                  <tr>
                    <td>Лимит отзывов в месяц</td>
                    <td>100</td>
                    <td>250</td>
                    <td>600</td>
                    <td>1200</td>
                    <td>от 1200</td>
                  </tr>
                  <tr>
                    <td>Количество анкет</td>
                    <td>2</td>
                    <td>5</td>
                    <td>10</td>
                    <td>20</td>
                    <td><span className={ styles.unlimited }>неограниченное</span><span className={ styles.unlimited }>∞</span></td>
                  </tr>
                  <tr>
                    <td>Количество объектов оценки (уникальные QR коды)</td>
                    <td>20</td>
                    <td>100</td>
                    <td>250</td>
                    <td>500</td>
                    <td>от 500</td>
                  </tr>
                  <tr>
                    <td>Количество вопросов в 1 анкете</td>
                    <td>5</td>
                    <td>5</td>
                    <td>7</td>
                    <td>8</td>
                    <td>10</td>
                  </tr>
                  <tr>
                    <td>Super QR</td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                  </tr>
                  <tr>
                    <td>Количество виджетов в Super QR</td>
                    <td>5</td>
                    <td>10</td>
                    <td>15</td>
                    <td>15</td>
                    <td>20</td>
                  </tr>
                  <tr>
                    <td>Готовые шаблоны анкет</td>
                    <td>100+</td>
                    <td>100+</td>
                    <td>100+</td>
                    <td>100+</td>
                    <td>100+</td>
                  </tr>
                  <tr>
                    <td>Мобильное приложение для администрирования и контроля</td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                  </tr>
                  <tr>
                    <td>Настройка автоматической рассылки аналитических отчетов по email адресам</td>
                    <td />
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                  </tr>
                  <tr>
                    <td>Возможность начислять бонусы за отзывы (Скоро)</td>
                    <td />
                    <td />
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                  </tr>
                  <tr>
                    <td>Анкеты с адаптивным дизайном</td>
                    <td />
                    <td />
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                  </tr>
                  <tr>
                    <td>Карта с GPS  метками отзывов</td>
                    <td />
                    <td />
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                  </tr>
                  <tr>
                    <td>Возможность позвонить респонденту</td>
                    <td />
                    <td />
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                    <td><span className={ styles.pin } /></td>
                  </tr>
                  <tr>
                    <td>Персональная BI аналитика с дашбордом</td>
                    <td />
                    <td />
                    <td />
                    <td />
                    <td><span className={ styles.pin } /></td>
                  </tr>
                  { !this.state.moreRules
                    && (
                      <tr>
                        <td colSpan="6" className={ styles.lastLine }>Не уверены, что именно вам подходит? <span className={ styles.link } onClick={ () => this.setState({ moreRules: true }) }>Обзор функций</span></td>
                      </tr>
                    )}
                  { this.state.moreRules
                  && (
                    <>
                      <tr style={{ height: '80px' }}>
                        <td colSpan="6"><span className={ styles.heading }>Создание анкеты</span></td>
                      </tr>
                      <tr>
                        <td>Готовые шаблоны анкет</td>
                        <td>100+</td>
                        <td>100+</td>
                        <td>100+</td>
                        <td>100+</td>
                        <td>100+</td>
                      </tr>
                      <tr>
                        <td>Копирование анкет</td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>8 типов вопросов</td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Добавление изображений</td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr style={{ height: '80px' }}>
                        <td colSpan="6"><span className={ styles.heading }>Дизайн & брендирование</span></td>
                      </tr>
                      <tr>
                        <td>Готовые шаблоны дизайнов</td>
                        <td>200+</td>
                        <td>200+</td>
                        <td>200+</td>
                        <td>200+</td>
                        <td>200+</td>
                      </tr>
                      <tr>
                        <td>Логотип вашей компании в анкете</td>
                        <td />
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr style={{ height: '80px' }}>
                        <td colSpan="6"><span className={ styles.heading }>Мобильное приложение</span></td>
                      </tr>
                      <tr>
                        <td>Мобильное приложение для администрирования и контроля</td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Возможность позвонить респонденту</td>
                        <td />
                        <td />
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr style={{ height: '80px' }}>
                        <td colSpan="6"><span className={ styles.heading }>Онлайн меню</span></td>
                      </tr>
                      <tr>
                        <td>Просмотр меню</td>
                        <td />
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Вызов официанта</td>
                        <td />
                        <td />
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Интеграция с кассой</td>
                        <td />
                        <td />
                        <td />
                        <td />
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr style={{ height: '80px' }}>
                        <td colSpan="6"><span className={ styles.heading }>Административная вебпанель</span></td>
                      </tr>
                      <tr>
                        <td>Пуш уведомление о негативных отзывах</td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Статистика отзывов реальном времени в моб.приложении (Скоро)</td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Карта с GPS метками отзывов</td>
                        <td />
                        <td />
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Возможность позвонить респонденту</td>
                        <td />
                        <td />
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Аудио запись разговора с клиентом</td>
                        <td />
                        <td />
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Автоматический Пуш/СМС сообщение в ответ на отзыв (Скоро)</td>
                        <td />
                        <td />
                        <td />
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Социально-демографический профиль респондента (Скоро)</td>
                        <td />
                        <td />
                        <td />
                        <td />
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Включение фильтра ограничения отправки отзыв по географии/локации (Скоро)</td>
                        <td />
                        <td />
                        <td />
                        <td />
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr style={{ height: '80px' }}>
                        <td colSpan="6"><span className={ styles.heading }>Анализ результатов</span></td>
                      </tr>
                      <tr>
                        <td>Базовые виды графиков (круговая, гистограмма, гистограмма с разделением)</td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Формирование шаблонов аналитических отчетов (PDF)</td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Логотип компании в итоговом отчете (брендирование)</td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Экспорт массива данных в XLS, CSV, XML, Google Sheets и др.</td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Настройка автоматической рассылки аналитических отчетов по email адресам</td>
                        <td />
                        <td />
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Персональная BI аналитика с дашбордом</td>
                        <td />
                        <td />
                        <td />
                        <td />
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr style={{ height: '80px' }}>
                        <td colSpan="5"><span className={ styles.heading }>Аккаунт и поддержка</span></td>
                      </tr>
                      <tr>
                        <td>Обучение работе с системой, часов</td>
                        <td>0,5</td>
                        <td>2</td>
                        <td>4</td>
                        <td>8</td>
                        <td>от 20</td>
                      </tr>
                      <tr>
                        <td>Поддержка по е-мэйл 24/7</td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Локальные методы оплаты</td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                      <tr>
                        <td>Предоставление счета-фактуры</td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                        <td><span className={ styles.pin } /></td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <p>* Цены указаны без учета НДС, который зависит от вашей страны. Финальную цену вы увидите на странице оплаты еще до совершения покупки.</p>
            <h3>Доступно во всех Премиум пакетах</h3>
            <ul className={ styles.features }>
              <li><span>Анкеты с адаптивным дизайном</span></li>
              <li><span>Мгновенная обработка результатов</span></li>
              <li><span>Безопасность (SSL)</span></li>
              <li><span>Премиум поддержка</span></li>
            </ul>
            <div className={ styles.safety }>
              <div className={ styles.safetyInner }>
                <h3>100% БЕЗОПАСНАЯ</h3>
                <p>покупка онлайн</p>
                <p>Безопасность для нас самое главное.</p>
              </div>
            </div>
            <div className={ styles.decision }>
              <h2>Необходимо уникальное решение для вашей компании?</h2>
              <p>Если у вас особый случай, вы можете обратиться к нам, и мы адаптируем MVoter под ваши уникальные задачи</p>
              <ul className={ styles.buttons }>
                <li><span onClick={ () => this.setState({ modal: true }) }>Регистрация</span></li>
                <li><span onClick={ () => this.setState({ modal: true }) }>Запросить демонстрацию</span></li>
              </ul>
            </div>
          </div>
        </div>
        { this.state.modal
          && (
            <Modal
              title="Запросить демонстрацию"
              content={ <Join onCloseClick={ () => this.setState({ modal: false }) } /> }
              onCloseClick={ () => this.setState({ modal: false }) }
            />
          )}
        { this.state.modalType !== ''
          && (
            <Modal
              title={ `Апгрейд на ${this.state.modalType} план` }
              styles={{ width: '680px' }}
              content={(
                <SubscribeModal
                  history={ this.props.history }
                  user={ this.props.user }
                  modalInnerType={ this.state.modalInnerType }
                  modalType={ this.state.modalType }
                  tariff={ this.state.tariff[this.state.modalType] }
                  onCloseClick={ () => this.setState({ modalType: '' }) }
                />
              )}
              onCloseClick={ () => this.setState({ modalType: '' }) }
            />
          )}
      </div>,
      <Footer key="3" subId="page" />
    ];
  }
}

export default connect(
  state => ({
    user: state.auth.user
  }),
  {}
)(Tariff);
